import type { ComponentType } from 'react';

import { Chip, ChipSize, ChipVariant } from '@ui/uikit/components/common/Chip';
import { ArrowLongRight } from '@ui/uikit/components/icons/mono/ArrowLongRight';
import { Chest } from '@ui/uikit/components/icons/mono/Chest';
import { TrendDown } from '@ui/uikit/components/icons/mono/TrendDown';
import { TrendUp } from '@ui/uikit/components/icons/mono/TrendUp';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import {
  getPredictionRoundResult,
  PredictionRoundState,
} from '../../../../../../../model/AdjacentRound/roundState';
import { RoundResult } from '../../../../../../../model/RoundResult';

type PredictionLabelProps = {
  round: AdjacentRound;
};

type ChipConfigItem = {
  variant: ChipVariant;
  icon: ComponentType;
  text: string;
};

export const PredictionChip = ({ round }: PredictionLabelProps) => {
  const roundResult = getPredictionRoundResult(round);

  const ChipConfig: Record<RoundResult, ChipConfigItem> = {
    [RoundResult.UP]: {
      variant: ChipVariant.GREEN,
      icon: TrendUp,
      text: 'UP Won!',
    },
    [RoundResult.DOWN]: {
      variant: ChipVariant.RED,
      icon: TrendDown,
      text: 'DOWN Won!',
    },
    [RoundResult.DRAW]: {
      variant: round.state === PredictionRoundState.CLOSED ? ChipVariant.DEFAULT : ChipVariant.PINK,
      icon: ArrowLongRight,
      text: 'Draw',
    },
  };

  const { variant, icon, text } = ChipConfig[roundResult];

  if (round.state === PredictionRoundState.CLOSED) {
    return <Chip size={ChipSize.LARGE} icon={icon} variant={variant} text={text} />;
  }

  if (round.state === PredictionRoundState.ACTIVE) {
    return (
      <div className="w-12 h-12 rounded-full bg-base-bg-secondary-orange flex justify-center items-center m-auto">
        <Chest className="icon-xs text-base-text-orange" />
      </div>
    );
  }

  return (
    <Chip
      isReversed={roundResult !== RoundResult.DRAW}
      icon={icon}
      size={ChipSize.LARGE}
      variant={variant}
      text={round.priceChange.formatted}
    />
  );
};
